export default "__VITE_ASSET__BjqACzOD__"